//import { turnosMock } from "../mockdata/turnosMokeados.js";
//import axios from 'axios';
import clienteHttp from "./ClienteHttps.js";

//const API_BASE_URL = 'http://localhost:3001';
/*
export const traerTurnosMock = () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(turnosMock);
        }, 1500);
      });
    };
*/

export const turnosService = {
    /**
     *  Reserva múltiple de turnos
     */
    async reservarMultiples(data) {
        try {
            const response = await clienteHttp.post(
                `/paciente/turnos/reservar-multiples`,
                {
                    idPaciente: data.idPaciente,
                    idsTurnos: data.idsTurnos
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error al reservar múltiples turnos:', error);
            
            // Si el backend devolvió 207 (Multi-Status)
            if (error.response && error.response.status === 207) {
                return error.response.data;
            }

            if (error.response && error.response.data?.mensaje) {
                throw new Error(error.response.data.mensaje);
            }

            throw new Error('Error de conexión con el servidor');
        }
    }
}